// extracted by mini-css-extract-plugin
export default {"wrapper":"CompleteAccount_wrapper__8gDFf","logo":"CompleteAccount_logo__jDP07","main_container":"CompleteAccount_main_container__+uGoU"};